import { render, staticRenderFns } from "./TabPane.vue?vue&type=template&id=c5433a50"
import script from "./TabPane.vue?vue&type=script&lang=js"
export * from "./TabPane.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data0/web/xyadmin.98du.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5433a50')) {
      api.createRecord('c5433a50', component.options)
    } else {
      api.reload('c5433a50', component.options)
    }
    module.hot.accept("./TabPane.vue?vue&type=template&id=c5433a50", function () {
      api.rerender('c5433a50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/tab/components/TabPane.vue"
export default component.exports